export default "__VITE_ASSET__28266398__"